const key = 'ramcides-it-helpdesk-2026';

const xorDecrypt = (text) => {
    return text.split('').map((char, i) => 
        String.fromCharCode(char.charCodeAt(0) ^ key.charCodeAt(i % key.length))
    ).join('');
};

export const decryptVendorParams = (token) => {
    if (!token) return null;
    try {
        const xored = atob(token);
        const payload = xorDecrypt(xored);
        return JSON.parse(payload);
    } catch (e) {
        console.error("Failed to decrypt vendor token", e);
        return null;
    }
};
